import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody,
} from "reactstrap";
import { SuccessOk } from "configs/statusCode";
import RattingService from "services/Admin/RattingService"
import CardItem from "./CardItem"
import ModalForm from "./ModalForm"
import EditModal from "./EditModal"
import Pagination from "./Pagination"
import SuccessModal from "components/SucessModal"
import DeveloperService from "services/Admin/DeveloperService"
import FilterIcon from "assets/images/filter.png"
import FilterModal from "./FilterModal"
import { useSelector } from "react-redux"

const RattingPage = ({ }) => {
    const service = new RattingService()
    const [modal, setModal] = useState(false);
    const [active, setActive] = useState("all");
    const [editRate, setEditRate] = useState(null)
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const [add, setAdd] = useState(true)
    const [searchWord, setSearchWord] = useState("")
    const [list, setList] = useState([])
    const [developersList, setDevelopersList] = useState([])
    const [pageList, setPageList] = useState([])
    const [deletedRatesList, setDeletedRatesList] = useState([])
    const [filterModal, setFilterModal] = useState(false)
    const [developerOptions, setDeveloperOptions] = useState([])
    const [defaultDeveloperOptions, setDefaultDeveloperOptions] = useState([])
    const [filtersRate, setFiltersRate] = useState(null)
    const [viewStatus, setViewStatus] = useState(false)
    const [areasFilter, setAreasFilter] = useState([])
    const [showContent, setShowContent] = useState(false)
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const developerService = new DeveloperService()

    const updateFiltersData = (data) => {
        if (data.toRate || data.fromRate || data?.areas?.length > 0 ) {
            setFiltersRate(data)
        } else {
            setFiltersRate(null)
        }
        setAreasFilter([...data?.areas])
    }

    useEffect(() => {
        developerService.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en ? item.name.en : item.name,
                    value: item.id
                }
            })
            setDefaultDeveloperOptions([...newOptions])
            updateDeveloperOptions(newOptions, list)

        })
    }, [])

    useEffect(() => {
        if (list.length === 0) {
            setShowContent(false)
        } else {
            setShowContent(true)
        }
        updateDeveloperOptions(defaultDeveloperOptions, list)
    }, [list,developersList])

    const updateDeveloperOptions = (defaultDeveloperOptions, list) => {
        const updated = defaultDeveloperOptions.filter(({ value }) => !developersList.some(({ developer_id }) => parseInt(value) === parseInt(developer_id)))
        setDeveloperOptions([...updated])
    }
    const getList = () => {
        setList([])
        const params = {};
        if (active != 'all') params['status'] = active === "active" ? 1 : 0

        if (searchWord.trim().length) {
            params['keyword'] = searchWord
        }
        if (areasFilter?.length) params['area_ids'] = areasFilter?.map(area => area.value)?.join()

        // if (filtersRate) {
        //     params['rate_range'] = `${filtersRate.fromRate}-${filtersRate.toRate}`

        // }
        // filter happened on total rate

        //  const updatedRate=list.map(item=>{
        //     if(item.rate >= filtersRate.fromRate && item.rate <= filtersRate.toRate){
        //         return item
        //     }
        //  })
        //  setList([...updatedRate])
        // uncomment this if we want to filter on craterias with selected Range 
        service.getList(params).then(res => {
            if (res && res.status === SuccessOk) {
                customizeRates(res.data)
            }
        })
    }

    const customizeRates = (rates) => {
        if (rates.length === 0) {
            return
        }
        const DeveloperRates = []
        for (const developer in rates) {
            const developerRate = {
                name: developer,
                developer_id: rates[developer][0].developer_id,
                craterias: [],
                rate: 0,
                count: 0,
                id: rates[developer][0].id,
                status: rates[developer][0].status,
                areas: []
            }
            let areas = []
            rates[developer]?.map((item, index) => {
                areas?.push(...item.areas)
                developerRate?.areas?.push(...item.areas)
            })
            
            rates[developer]?.forEach((item, index) => {
                const crateria = {
                    id: item.id,
                    rating_criteria: item.rating_criteria,
                    rate: item.rate
                }
                developerRate.rate = developerRate.rate + item.rate
                developerRate.count = developerRate.count + 1
                developerRate.craterias.push(crateria)
            })

            if (filtersRate ?.fromRate && filtersRate ?.toRate ) {
                if (parseFloat(developerRate.rate / developerRate.count) >= parseFloat(filtersRate.fromRate)
                    && parseFloat(developerRate.rate / developerRate.count) <= parseFloat(filtersRate.toRate)) {
                    DeveloperRates.push(developerRate)
                }
            } else if (filtersRate ?.fromRate) {
                if (parseFloat(developerRate.rate / developerRate.count) >= parseFloat(filtersRate.fromRate)) {
                    DeveloperRates.push(developerRate)
                }
            } else if (filtersRate ?.toRate) {
                if (parseFloat(developerRate.rate / developerRate.count) >= parseFloat(filtersRate.toRate)) {
                    DeveloperRates.push(developerRate)
                }
            } else {
                DeveloperRates.push(developerRate)
            }
        }
        if (DeveloperRates.length === 0) {
            setList([])
            setDevelopersList([])
        } else {
            setList([...DeveloperRates])
            setDevelopersList([...DeveloperRates])
        }
    }

    const addHandler = () => {
        setAdd(true)
        setEditRate(null)
        toggle()
    }
    const toggle = () => {
        if (modal) {
            setViewStatus(false)
        }
        setDeletedRatesList([])
        setModal(!modal);
    }

    const OnSearchChange = (e) => {
        const search = e.target.value
        setSearchWord(search)

    }
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            getList()
        }, 1000)
        return () => clearTimeout(timeoutId)

    }, [active, searchWord, filtersRate, areasFilter])

    const onChangePage = (pageOfItems) => {
        // update state with new page of items
        if (list.length === 0) {
            setPageList([])

        } else {
            setPageList(pageOfItems)

        }
    }
    const updateHandler = (editRate) => {
        setAdd(false)
        setEditRate(editRate)
        toggle(true)
    }
    const viewHandler = (editRate) => {
        setAdd(false)
        setEditRate(editRate)
        toggle(true)
        setViewStatus(true)
    }

    return (
        <React.Fragment>
            <div className='page-content' >
                <MetaTags>
                    <title>Rates</title>
                </MetaTags>
                <Container fluid >
                    <Row>
                        <Col md={6}>
                            <h4>Manage Rates</h4>
                            <p>Admin can add rate to any developer</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <div className="form-group has-search">
                                <span className="fa fa-search form-control-feedback"></span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={"Search by developer name, I.D"}
                                    onChange={(e) => OnSearchChange(e)}
                                    value={searchWord} />
                            </div>
                        </Col>
                        {isExist("rate.add") ? <Col md={6}>
                            <div className="d-md-flex justify-content-md-end mb-2">
                                <button className="btn btn-success btnHeight px-lg-4" onClick={addHandler}>Add New Rate </button>
                            </div>
                        </Col> : null}
                    </Row>
                    <Row className="mb-4 d-flex justify-content-between">
                        <Col md={8} className="mb-3">
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "all" ? "#556ee6" : "#f4f4f4",
                                    color: active == "all" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("all")
                                }}
                            >
                                All
                            </button>
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "active" ? "#556ee6" : "#f4f4f4",
                                    color: active == "active" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("active")
                                }}
                            >
                                Active
                            </button>
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                                    color: active == "deactive" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("deactive")
                                }}
                            >
                                Deactive
                            </button>
                        </Col>
                        {filtersRate &&
                            <Col md={2} className=" mb-3 px-0 d-flex justify-content-between " style={{ background: "#e8e8e8", borderRadius: "8px", paddingTop: "12px" }}>
                                <span className=" fw-bold font-size-13 mx-3  "> {filtersRate.fromRate && ` From ${filtersRate.fromRate}`} {filtersRate.fromRate ? filtersRate.toRate ? ` - ` : null : null}  {filtersRate.toRate && `To ${filtersRate.toRate}`}</span>
                                {filtersRate?.areas?.length > 0 && <span className=" fw-bold font-size-13 mx-3  "> {`${filtersRate.areas?.map((area, index) => {
                                    return ` ${area.label}`
                                })}`} </span>}
                                <span className="fw-bold font-size-13 mx-3  " style={{ cursor: "pointer" }} onClick={() => {
                                    setFiltersRate(null)
                                    setAreasFilter([])
                                    }}>X</span>
                            </Col>}
                        <Col sm={2} className="mb-3 d-flex flex-row-reverse">
                            <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                                setFilterModal(true)
                            }}> <img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
                        </Col>
                    </Row>
                    <div>
                        <Card className="w-100">
                            <CardBody>
                                <div className='py-3'>
                                    <div>
                                        <div className="table-responsive">
                                            <Table>
                                                <thead>
                                                    <tr className='bgHeaderTable'>
                                                        <th className='font-size-16'>I.D</th>
                                                        <th className='font-size-16'>Developer Name</th>
                                                        <th className='font-size-16'>Total Rate</th>
                                                        <th className='font-size-16'>Locations</th>
                                                        <th className='font-size-16'>Status</th>
                                                        <th className='font-size-16'></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {showContent ? pageList.map((item, index) => {
                                                        return (
                                                            <CardItem
                                                                key={index}
                                                                index={index}
                                                                {...item}
                                                                getList={getList}
                                                                item={item}
                                                                Service={RattingService}
                                                                updateHandler={() => updateHandler(item)}
                                                                viewHandler={() => viewHandler(item)}
                                                            />
                                                        )
                                                    }) : null}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                    {modal ? <EditModal
                        add={add}
                        modal={modal}
                        toggle={toggle}
                        getList={getList}
                        Service={RattingService}
                        editRate={editRate}
                        developers={developerOptions}
                        setShowSuccessModal={setShowSuccessModal}
                        setDeletedRatesList={setDeletedRatesList}
                        deletedRatesList={deletedRatesList}
                        setViewStatus={setViewStatus}
                        viewStatus={viewStatus}
                    /> : null
                    } {showSuccessModal && <SuccessModal
                        modal={showSuccessModal}
                        title={"Add New Rate"}
                        subtitle={"Admin can add rate to any developer"}
                        message={"The Rate successfully Added"}
                        onClick={() => {
                            getList()
                            setShowSuccessModal(false)
                        }} />}
                     {list.length ?
                        <Row className="d-flex justify-content-end">
                            <Pagination items={list} onChangePage={onChangePage} />
                        </Row> : null
                    }
                    {filterModal ? <FilterModal
                        filterModal={filterModal}
                        setFilterModal={setFilterModal}
                        setFiltersRate={setFiltersRate}
                        updateFiltersData={updateFiltersData}
                        filtersRate={filtersRate}
                    /> : null}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default RattingPage;
